let room = null;
let localVideoTrack = null;
let localVideoTrackForCallSetting = null;
let localAudioTrack = null;
let screenShareLocalTrack = null;
let localTracks = null;

export const setRoom = (newRoom) => {
    room = newRoom;
};

export const getRoom = () => room;

export const setLocalVideoTrack = (track) => {
    localVideoTrack = track;
};

export const getLocalVideoTrack = () => localVideoTrack;

export const setLocalVideoTrackForCallSetting = (track) => {
    localVideoTrackForCallSetting = track;
};

export const getLocalVideoTrackForCallSetting = () => localVideoTrackForCallSetting;

export const setLocalAudioTrack = (track) => {
    localAudioTrack = track;
};

export const getLocalAudioTrack = () => localAudioTrack;

export const setScreenShareLocalTrack = (track) => {
    screenShareLocalTrack = track;
};

export const getScreenShareLocalTrack = () => screenShareLocalTrack;

export const setLocalTracks = (track) => {
    localTracks = track;
};

export const getLocalTracks = () => localTracks;

export const resetRoom = () => {
    room = null;
};

export const resetRoomState = () => {
    room = null;
    localVideoTrack = null;
    localTracks = null;
    localVideoTrackForCallSetting = null;
};
